import _ from 'lodash'
import moment from 'moment'
import {
  getInstructionFiles,
  getSdsFiles,
} from '../../../helpers/Manufacturer/manufacturerCatalog'
import noImage from '~/ZenOne-StoryBook/img/no-image.svg'
import noImageProduct from '~/ZenOne-StoryBook/img/no-image-product.svg'
import {
  isArrayWithLength,
  isNotUndefined,
} from '~/ZenOne-StoryBook/helpers/types'
import {
  isHavingProps,
  isObjectNotUndefinedHasProps,
} from '~/ZenOne-StoryBook/helpers/object'
import { mapCategories } from '~/ZenOne-StoryBook/helpers/category'
import { API as api } from '~/ZenOne-StoryBook/config/api'
import { capitalizeFirstLetter } from '~/ZenOne-StoryBook/helpers/format'
import { isArrayAndHaveLength } from '~/ZenOne-StoryBook/helpers/array'

export const DIALOG_EDIT_CATEGORIES = 'dialogEditCategories'

export const getProductById = (id = null, products = []) => {
  if (id) {
    if (products && Array.isArray(products) && products.length) {
      id = parseInt(id)
      const index = products.findIndex((product) => parseInt(product.id) === id)
      if (index !== -1) return products[index]
    }
  }
  return {}
}

export const checkParamsForStatusDeletedFilter = (
  params,
  filters,
  isDownload = false
) => {
  const statusFilterValue =
    filters?.['filter[product.status]'] || filters?.['filter[status]']
  if (
    isNotUndefined(statusFilterValue) &&
    statusFilterValue.includes(status.DELETED)
  ) {
    if (!isDownload) {
      params['filter[products.with-trashed]'] = true
    } else {
      params['filter[with-trashed]'] = true
    }
  }
  return params
}

export const status = {
  DRAFT: 'draft',
  IN_REVIEW: 'in_review',
  ACTIVE: 'active',
  DISCONTINUED: 'discontinued',
  DELETED: 'deleted',
}
export const statusList = [
  { id: 1, text: 'Draft', value: status.DRAFT },
  { id: 2, text: 'In Review', value: status.IN_REVIEW },
  { id: 3, text: 'Active', value: status.ACTIVE },
  { id: 4, text: 'Discontinued', value: status.DISCONTINUED },
  { id: 5, text: 'Deleted', value: status.DELETED },
]
export const filterAliasList = {
  GROUP_FILTER_ALIAS: 'group',
  DESCRIPTION_FILTER_ALIAS: 'description',
  CATEGORY_FILTER_ALIAS: 'category',
  WITHOUT_CATEGORIES_FILTER_ALIAS: 'withoutCategories',
  STATUS_FILTER_ALIAS: 'status',
  PACKAGE_FILTER_ALIAS: 'packageMeasure',
  MANUFACTURER_FILTER_ALIAS: 'manufacturer',
  DISTRIBUTOR_FILTER_ALIAS: 'distributor',
  HAS_NOT_SPECIFIED_FILTER_ALIAS: 'hasNotSpecified',
}
export const sortTypes = {
  BY_PRODUCT_NAME: 'name',
  BY_PRICE: 'product.price',
  PRODUCT_DISTRIBUTORS_COUNT: 'productDistributorsCount',
}

export const mapProductModels = (
  data = [],
  selected = [],
  sellDirect = false,
  modifierList = []
) => {
  return _.map(data, (el) => {
    let isProductModel = false
    let children = []
    const products = el?.['products-with-trashed']?.data ?? el?.products?.data
    if (isNotUndefined(products)) {
      if (products.length > 1) {
        isProductModel = true
        children = _.map(products, (childrenItem) => {
          const modId = getModId(el)
          const modifierValuesData = getModifiersValuesData(childrenItem, modId)

          let img = ''
          const productImg = childrenItem?.images?.data?.[0]?.path
          const noImageFlag = childrenItem?.noImage
          if (productImg) {
            img = productImg
          } else if (noImageFlag) {
            img = noImageProduct
          } else {
            img = noImage
          }

          return {
            productCreatedAt: childrenItem?.createdAt
              ? moment(childrenItem?.createdAt).format('MM/DD/YY')
              : 'N/A',
            productDistributorId: sellDirect
              ? getDistributorField(childrenItem, 'id', true)
              : null,
            stockLevel: sellDirect
              ? getDistributorField(childrenItem, 'stockLevel', true)
              : null,
            distributorSku: sellDirect
              ? getDistributorField(childrenItem, 'sku', true)
              : null,
            'modifier-values': childrenItem['modifier-values'],
            nameModel: el.name,
            id: childrenItem.id,
            parameters: childrenItem.parameters,
            description: childrenItem.description,
            packageQty: childrenItem.packageQty,
            packageMeasure: childrenItem.packageMeasure,
            sdsFiles: getSdsFiles(childrenItem), // todo check
            instructionFiles: getInstructionFiles(childrenItem),
            img,
            imgAll: getChildImgAll(childrenItem),
            name: childrenItem.name,
            package: childrenItem.packageQty,
            unit: childrenItem.packageMeasure,
            price: childrenItem.price,
            sku: childrenItem.sku,
            status: childrenItem.status,
            freeGood: null,
            distributors: childrenItem?.productDistributorsCount,
            manufacturer: getChildManufacturer(el),
            modifiers: childrenItem.modifiers,
            modifierValues: getModifiersValues(modifierValuesData),
            modifierValueList: getModifierValueList(childrenItem, modifierList),
            modifierId: getModifierId(modifierValuesData),
            formulary: childrenItem?.zenChoice,
          }
        })
      }
      const inSelected = selected.findIndex(
        (selectedProductId) => parseInt(selectedProductId) === parseInt(el.id)
      )

      let img = ''
      const productImg = el?.products?.data?.[0]?.images?.data?.[0]?.path
      const noImageFlag = el?.products?.data?.[0]?.noImage
      if (productImg) {
        img = productImg
      } else if (noImageFlag) {
        img = noImageProduct
      } else {
        img = noImage
      }
      const { categoryList = [] } = el
      return {
        // distributor part
        productDistributorId: sellDirect ? getDistributorField(el, 'id') : null,
        stockLevel: sellDirect ? getDistributorField(el, 'stockLevel') : null,
        priceZen: sellDirect ? getDistributorField(el, 'priceZen') : null,
        priceRetail: sellDirect ? getDistributorField(el, 'priceRetail') : null,
        distributorSku: sellDirect ? getDistributorField(el, 'sku') : null,
        /// ///////////////
        id: el?.id,
        productCreatedAt: el?.products?.data?.[0]?.createdAt
          ? moment(el?.products?.data?.[0]?.createdAt).format('MM/DD/YY')
          : 'N/A',
        isProductModel,
        checked: inSelected > -1,
        imgAll: getImgAll(products),
        img,
        sdsFiles: getSdsFiles(products[0]),
        instructionFiles: getInstructionFiles(products[0]),
        name: products[0] ? products[0].name : null,
        nameGroup: el.name,
        description: products?.[0]?.description ?? null,
        product: getProduct(el, products),
        ...mapCategories(categoryList),
        categoryId: el?.categoryId ?? null,
        manufacturer: el.manufacturer.data,
        sku: products[0] ? products[0].sku : null,
        package: products[0] ? products[0].packageQty : null,
        unit: products[0] ? products[0].packageMeasure : null,
        price: products[0] ? products[0].price : null,
        status: products[0] ? products[0].status : null,
        productId: products[0] ? products[0].id : null,
        distributors: products?.[0]?.productDistributorsCount,
        modifiers: el.modifiers.data[0],
        modifierValueList: getModifierValueList(products[0], modifierList),
        productModelModifier: el['product-model-modifier']
          ? el['product-model-modifier'].data
          : null,
        formulary: products?.[0]?.zenChoice,
        children,
        videoLink: el?.video_link ?? [''],
        otherInfo: el?.other_info ?? null,
        additionalDescription:
          products[0]?.parameters?.additionalDescription ?? '',
      }
    }
  })
}

export const getModifierValueList = (product, modifierList = []) => {
  const list = []
  if (!isArrayAndHaveLength(modifierList)) return []
  const values = product?.['modifier-values']?.data
  if (!isNotUndefined(values)) return []
  modifierList.forEach((modifier) => {
    const item = {
      ...modifier,
      name: modifier?.name ? capitalizeFirstLetter(modifier.name) : '',
      value: null,
    }
    values.forEach((value) => {
      if (parseInt(modifier.id) === parseInt(value.modifierId)) {
        item.value = value?.value ? capitalizeFirstLetter(value?.value) : ''
        item.modifierValueId = value?.id
      }
    })
    list.push(item)
  })
  list.sort((a, b) => a.name.localeCompare(b.name))
  return list
}

export const getProduct = (el, products) => {
  if (
    el &&
    isHavingProps(el) &&
    products &&
    Array.isArray(products) &&
    products.length > 0
  ) {
    if (isNotUndefined(products?.[0])) {
      const productData = products[0]
      let imagesData = []
      const resultProductOnly = {
        ...productData,
        imgAll: [],
      }
      if (
        isNotUndefined(
          products?.[0]?.images?.data && products[0].images.data.length > 0
        )
      ) {
        imagesData = products[0].images.data
        if (imagesData && imagesData.length > 0) {
          return {
            ...resultProductOnly,
            imgAll: products[0].images.data,
          }
        } else {
          return resultProductOnly
        }
      } else {
        return resultProductOnly
      }
    } else {
      return null
    }
  }
  return null
}

export const getDistributorField = (item, fieldName, child = false) => {
  if (item && isHavingProps(item) && fieldName) {
    let value
    if (!child) {
      value =
        item?.['products-with-trashed']?.data?.[0]?.['product-distributors']
          ?.data?.[0]?.[fieldName]
    } else {
      value = item?.['product-distributors']?.data?.[0]?.[fieldName]
    }
    return isNotUndefined(value) ? value : null
  }
  return null
}

export const getImgAll = (products) => {
  if (products && Array.isArray(products) && products.length > 0) {
    return isNotUndefined(products?.[0]?.images?.data)
      ? products[0].images.data
      : null
  }
  return null
}
export const getParentImage = (item) => {
  const isCatalog = item?.['products-with-trashed']?.data
  const productsProp = isNotUndefined(isCatalog)
    ? 'products-with-trashed'
    : 'products'
  const thumbPath =
    item?.[productsProp]?.data?.[0]?.images?.data?.[0]?.thumb?.data?.path
  if (isNotUndefined(thumbPath)) return thumbPath
  const imgPath = item?.[productsProp]?.data?.[0]?.images?.data?.[0]?.path
  if (isNotUndefined(imgPath)) return imgPath
}
export const getChildThumb = (childItem) => {
  const path = childItem?.images?.data?.[0]?.thumb?.data?.path
  return isNotUndefined(path) ? path : null
}
export const getChildImgAll = (childItem) => {
  const imgAll = childItem?.images?.data
  return isNotUndefined(imgAll) ? imgAll : null
}
export const getChildManufacturer = (el) => {
  const manufacturer = el?.manufacturer.data
  return isNotUndefined(manufacturer) ? manufacturer : null
}
export const getModId = (el) => {
  const modId = el?.modifiers?.data?.[0]?.id
  return isNotUndefined(modId) ? modId : null
}
export const getModifiersValuesData = (childItem, modId = null) => {
  if (modId) {
    const modifiersValues = childItem?.['modifier-values']?.data
    if (!isNotUndefined(modifiersValues)) return null
    return _.find(
      childItem['modifier-values'].data,
      (m) => parseInt(m.modifierId) === parseInt(modId)
    )
  }
  return null
}
export const getModifiersValues = (modifiersValuesData) => {
  return modifiersValuesData && isNotUndefined(modifiersValuesData?.value)
    ? modifiersValuesData.value
    : null
}
export const getModifierId = (modifiersValuesData) => {
  return modifiersValuesData && isNotUndefined(modifiersValuesData?.modifierId)
    ? modifiersValuesData.modifierId
    : null
}

export const fetchProductModelsIncludeString = `product-model-modifier,modifiers,${api.PRODUCTS}.modifier-values,${api.PRODUCTS},${api.MANUFACTURER},${api.PRODUCTS}.modifiers,${api.PRODUCTS}.product-model,${api.PRODUCTS}.images.thumb,${api.PRODUCTS}.sds-file,${api.PRODUCTS}.instructions`
export const fetchProductModelsIncludeStringWithDeleted = `product-model-modifier,modifiers,${api.PRODUCTS_WITH_TRASHED}.modifier-values,${api.PRODUCTS_WITH_TRASHED},${api.MANUFACTURER},${api.PRODUCTS_WITH_TRASHED}.modifiers,${api.PRODUCTS_WITH_TRASHED}.product-model,${api.PRODUCTS_WITH_TRASHED}.images.thumb,${api.PRODUCTS_WITH_TRASHED}.sds-file,${api.PRODUCTS}.instructions`

export const getFetchProductsInclude = (isStatusFilterDeleted = false) => {
  return !isStatusFilterDeleted
    ? fetchProductModelsIncludeString
    : fetchProductModelsIncludeStringWithDeleted
}

export const getGenericIds = (genericName = {}, subcategory = {}) => {
  let list = []
  const genericNameId = genericName?.id ? parseInt(genericName.id) : null
  if (!genericNameId) {
    if (!isObjectNotUndefinedHasProps(subcategory)) return false
    const children = subcategory?.children
    if (!children || !isArrayAndHaveLength(children)) return false
    list = children.map((child) => parseInt(child.id))
  } else {
    list.push(genericNameId)
  }
  return list
}

export const getGenericIdsByGrandParent = (rootCategory = {}) => {
  const list = []
  const subcats = rootCategory?.children
  if (!isArrayWithLength(subcats)) return []
  for (const subcat of subcats) {
    const subcatChildren = subcat?.children ?? []
    if (!isArrayWithLength(subcatChildren)) continue
    for (const subcatChild of subcatChildren) {
      list.push(parseInt(subcatChild.id))
    }
  }
  return list
}

export const getActualModifiersList = async (ids = [], store = {}) => {
  const modifierList = mapModifiers(
    await fetchPrimaryModifiers(ids, store),
    'primary'
  )
  mapModifiers(await fetchSecondaryModifiers(ids, store), 'secondary').forEach(
    (item) => {
      modifierList.push(item)
    }
  )
  return modifierList
}

export const fetchPrimaryModifiers = async (ids = [], store = {}) => {
  return await fetchModifiersByCategory(ids, 'forPrimaryCategoryTreeId', store)
}

export const fetchSecondaryModifiers = async (ids = [], store = {}) => {
  return await fetchModifiersByCategory(
    ids,
    'forSecondaryCategoryTreeId',
    store
  )
}

export const fetchModifiersByCategory = async (
  idList = [],
  filterName = '',
  store = {}
) => {
  const params = {
    full: true,
    [`filter[${filterName}]`]: idList.join(),
  }
  return await store.dispatch('jv/get', [`${api.MODIFIERS}`, { params }])
}

export const mapModifiers = (data = {}, type = '') => {
  if (isObjectNotUndefinedHasProps(data)) {
    if (data?._jv) delete data._jv
    const list = Object.keys(data).reduce((acc, modifierId) => {
      acc.push({
        id: parseInt(modifierId),
        name: capitalizeFirstLetter(data?.[modifierId]?.name),
        values: data?.[modifierId]?.values,
        type,
      })
      return acc
    }, [])
    list.sort((a, b) => a.name.localeCompare(b.name))
    return list
  }
}
